import * as CryptoJS from 'crypto-js';

export class AES {
  static keyBase64:CryptoJS.lib.WordArray = CryptoJS.enc.Base64.parse('VW5hIGNhZGVuYSwgbXV5LCBtdXkgbGFyZ2EgcGFyYSA=');
  static ivBase64: CryptoJS.lib.WordArray = CryptoJS.enc.Base64.parse('znNoPM/MlY9zcoO2aQSU2g==');
  static cipherOPtions: any = { iv: AES.ivBase64 };

  /**
   * Encripta el objeto que recibe como parámetro y lo regresa en formato de cadena. 
   * @param message any, Objeto que sera encriptado
   * @returns string, resultado de la encripción del objeto recibido.
   */
  static encrypt(message: any): string {
    let mensaje: string = message;
    if(typeof message != 'string'){
      mensaje = JSON.stringify(message);
    }

    return CryptoJS.AES.encrypt(mensaje, this.keyBase64, this.cipherOPtions).toString();
  }

  /**
   * Recibe el hash (mensaje encriptado) y lo desencripta según el tipo.
   * @param hash string, mensaje encriptado
   * @returns Objeto o estring desencriptado
   */
  static decrypt(hash: string): any | string {
    let decrypted : string = CryptoJS.AES.decrypt(hash, this.keyBase64, {iv: this.ivBase64}).toString(CryptoJS.enc.Utf8);
    let first_elements = decrypted.substring(0, 3);

    if( first_elements.includes('{') || first_elements.includes('[') ){
      return JSON.parse(decrypted);
    }
    return decrypted;
  }

}